import { wrapper } from '../request';
export var ValidatePackageName = wrapper('publish')('ValidatePackageName');
export var PublishTheme = wrapper('publish')('PublishTheme');
export var getPublishLog = wrapper('publish')('getPublishLog');